// i18n.js — Traductions FR / AR / EN

export const APP_LOCALES = [
  { value: "fr", label: "Francais" },
  { value: "ar", label: "العربية" },
  { value: "en", label: "English" },
];
export const I18N = {
  fr: {
    tagline: "La gestion de copropriété qui coule de source",
    apiReady: "API locale connectee",
    apiDown: "API locale indisponible",
    login: "Se connecter",
    register: "S'inscrire",
    noAccount: "Pas encore de compte ?",
    alreadyRegistered: "Déjà inscrit ?",
    email: "Email",
    password: "Mot de passe",
    access: "Accéder à mon espace →",
    connecting: "Connexion...",
    ownerRegisterTitle: "Rejoindre une résidence",
    ownerRegisterDesc: "Entrez le code fourni par votre syndic pour créer votre compte.",
    verifyCode: "Vérifier le code →",
    validCode: "Code valide — remplissez vos informations",
    invalidCode: "Code d'invitation invalide ou expiré sur l'API. En mode démo, utilisez un code affiché ci-dessous.",
    ownerSubmitted: "Compte copropriétaire créé. Vous pouvez maintenant vous connecter en mode démo local.",
    syndicRegisterTitle: "Créer un compte syndic",
    syndicRegisterDesc: "Ce formulaire envoie directement les donnees a l'API locale Cloudflare.",
    providerRegisterTitle: "Contact prestataire",
    providerRegisterDesc: "Laissez vos informations et la plateforme vous recontactera pour activer votre espace prestataire.",
    providerSent: "Votre demande prestataire a bien été envoyée à la plateforme.",
    createSyndic: "Créer mon compte syndic →",
    sendRequest: "Envoyer ma demande →",
    sending: "Envoi...",
    creating: "Création...",
    nextSteps: "Prochaines étapes :",
    backToLogin: "← Retour à la connexion",
    residenceName: "Nom de la résidence *",
    city: "Ville",
    fullName: "Nom *",
    firstName: "Prénom *",
    phone: "Téléphone",
    apartment: "N° d'appartement * (ex: A101)",
    confirmPassword: "Confirmer le mot de passe *",
    providerCompany: "Société / marque *",
    providerCategory: "Catégorie de service *",
    providerMessage: "Décrivez vos services *",
    roleSyndic: "Syndic",
    roleOwner: "Copropriétaire",
    roleProvider: "Prestataire",
    roleAdmin: "Admin"
  },
  ar: {
    tagline: "إدارة الملكية المشتركة بكل سهولة",
    apiReady: "واجهة البرمجة المحلية متصلة",
    apiDown: "واجهة البرمجة المحلية غير متاحة",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    noAccount: "ليس لديك حساب؟",
    alreadyRegistered: "لديك حساب بالفعل؟",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    access: "الدخول إلى المساحة الخاصة بي ←",
    connecting: "جارٍ تسجيل الدخول...",
    ownerRegisterTitle: "الانضمام إلى إقامة",
    ownerRegisterDesc: "أدخل رمز الدعوة المقدم من السنديك لإنشاء حسابك.",
    verifyCode: "تحقق من الرمز →",
    validCode: "الرمز صالح — أكمل معلوماتك",
    invalidCode: "رمز الدعوة غير صالح أو منتهي في الواجهة. في وضع العرض استخدم رمزا من القائمة أدناه.",
    ownerSubmitted: "تم إنشاء حساب المالك المشترك. يمكنك الآن تسجيل الدخول في وضع العرض المحلي.",
    syndicRegisterTitle: "إنشاء حساب سنديك",
    syndicRegisterDesc: "هذا النموذج يرسل البيانات مباشرة إلى الواجهة المحلية Cloudflare.",
    providerRegisterTitle: "طلب تواصل مزود خدمة",
    providerRegisterDesc: "اترك معلوماتك وسيتم التواصل معك لتفعيل مساحة مزود الخدمة.",
    providerSent: "تم إرسال طلب مزود الخدمة إلى المنصة.",
    createSyndic: "إنشاء حساب السنديك →",
    sendRequest: "إرسال طلبي →",
    sending: "جارٍ الإرسال...",
    creating: "جارٍ الإنشاء...",
    nextSteps: "الخطوات التالية:",
    backToLogin: "← العودة إلى تسجيل الدخول",
    residenceName: "اسم الإقامة *",
    city: "المدينة",
    fullName: "الاسم العائلي *",
    firstName: "الاسم الشخصي *",
    phone: "الهاتف",
    apartment: "رقم الشقة *",
    confirmPassword: "تأكيد كلمة المرور *",
    providerCompany: "الشركة / العلامة *",
    providerCategory: "فئة الخدمة *",
    providerMessage: "صف خدماتك *",
    roleSyndic: "سنديك",
    roleOwner: "مالك مشترك",
    roleProvider: "مزود خدمة",
    roleAdmin: "مشرف"
  },
  en: {
    tagline: "Condo management made simple",
    apiReady: "Local API connected",
    apiDown: "Local API unavailable",
    login: "Sign in",
    register: "Create account",
    noAccount: "Don't have an account yet?",
    alreadyRegistered: "Already registered?",
    email: "Email",
    password: "Password",
    access: "Open my workspace →",
    connecting: "Signing in...",
    ownerRegisterTitle: "Join a residence",
    ownerRegisterDesc: "Enter the invitation code shared by your property manager.",
    verifyCode: "Verify code →",
    validCode: "Valid code — complete your details",
    invalidCode: "Invitation code is invalid or expired on the API. In demo mode, use one of the codes below.",
    ownerSubmitted: "Resident account created. You can now sign in in local demo mode.",
    syndicRegisterTitle: "Create a manager account",
    syndicRegisterDesc: "This form sends data directly to the local Cloudflare API.",
    providerRegisterTitle: "Provider contact form",
    providerRegisterDesc: "Leave your details and the platform will contact you to activate your provider workspace.",
    providerSent: "Your provider request has been sent to the platform.",
    createSyndic: "Create manager account →",
    sendRequest: "Send my request →",
    sending: "Sending...",
    creating: "Creating...",
    nextSteps: "Next steps:",
    backToLogin: "← Back to sign in",
    residenceName: "Residence name *",
    city: "City",
    fullName: "Last name *",
    firstName: "First name *",
    phone: "Phone",
    apartment: "Apartment number *",
    confirmPassword: "Confirm password *",
    providerCompany: "Company / brand *",
    providerCategory: "Service category *",
    providerMessage: "Describe your services *",
    roleSyndic: "Manager",
    roleOwner: "Resident",
    roleProvider: "Provider",
    roleAdmin: "Admin"
  }
};

export const getAppCopy = (locale) => ({
  fr: {
    syndicSpace: "Espace syndic",
    activeResidence: "Résidence active",
    admin: "Administrateur",
    logout: "← Déconnexion",
    dashboard: "Tableau de bord",
    residents: "Copropriétaires",
    cotisations: "Cotisations",
    billing: "Facturation",
    charges: "Charges",
    works: "Travaux",
    assemblies: "Assemblées AG",
    marketplace: "Marketplace",
    reports: "Rapports",
    recentActivity: "Activité récente",
    chargesSplit: "Répartition des charges",
    receivedFees: "Cotisations reçues",
    dueAmount: "Montant dû",
    totalCharges: "Total charges",
    latePayers: "Retardataires",
    waiting: "en attente",
    providerRequests: "Demandes prestataires",
    approve: "Approuver",
    reject: "Refuser",
    providerWorkspace: "Espace Prestataire",
    myProfile: "Mon profil",
    requests: "Demandes",
    statistics: "Statistiques",
    saveProfile: "Enregistrer le profil",
    services: "Services",
    pricing: "Tarifs",
    city: "Ville",
    profileUpdated: "Profil prestataire mis à jour.",
    adminWorkspace: "Admin plateforme",
    visitors: "Visiteurs",
    subscribers: "Abonnés",
    providers: "Prestataires",
    platformStats: "Statistiques plateforme",
    pendingProviders: "Demandes prestataires",
    validateProvider: "Valider",
    platformDashboard: "Dashboard plateforme"
  },
  ar: {
    syndicSpace: "مساحة السنديك",
    activeResidence: "الإقامة النشطة",
    admin: "مدير",
    logout: "← تسجيل الخروج",
    dashboard: "لوحة التحكم",
    residents: "الملاك المشتركون",
    cotisations: "المساهمات",
    billing: "الفوترة",
    charges: "المصاريف",
    works: "الأشغال",
    assemblies: "الجمعيات العامة",
    marketplace: "السوق",
    reports: "التقارير",
    recentActivity: "النشاط الأخير",
    chargesSplit: "توزيع المصاريف",
    receivedFees: "المساهمات المحصلة",
    dueAmount: "المبلغ المستحق",
    totalCharges: "إجمالي المصاريف",
    latePayers: "المتأخرون",
    waiting: "قيد الانتظار",
    providerRequests: "طلبات مزودي الخدمة",
    approve: "موافقة",
    reject: "رفض",
    providerWorkspace: "مساحة مزود الخدمة",
    myProfile: "ملفي",
    requests: "الطلبات",
    statistics: "الإحصائيات",
    saveProfile: "حفظ الملف",
    services: "الخدمات",
    pricing: "الأسعار",
    city: "المدينة",
    profileUpdated: "تم تحديث ملف مزود الخدمة.",
    adminWorkspace: "إدارة المنصة",
    visitors: "الزوار",
    subscribers: "المشتركون",
    providers: "مزودو الخدمة",
    platformStats: "إحصاءات المنصة",
    pendingProviders: "طلبات مزودي الخدمة",
    validateProvider: "اعتماد",
    platformDashboard: "لوحة المنصة"
  },
  en: {
    syndicSpace: "Manager workspace",
    activeResidence: "Active residence",
    admin: "Administrator",
    logout: "← Sign out",
    dashboard: "Dashboard",
    residents: "Residents",
    cotisations: "Fees",
    billing: "Billing",
    charges: "Expenses",
    works: "Works",
    assemblies: "General meetings",
    marketplace: "Marketplace",
    reports: "Reports",
    recentActivity: "Recent activity",
    chargesSplit: "Expense split",
    receivedFees: "Received fees",
    dueAmount: "Amount due",
    totalCharges: "Total expenses",
    latePayers: "Late payers",
    waiting: "pending",
    providerRequests: "Provider requests",
    approve: "Approve",
    reject: "Reject",
    providerWorkspace: "Provider workspace",
    myProfile: "My profile",
    requests: "Requests",
    statistics: "Statistics",
    saveProfile: "Save profile",
    services: "Services",
    pricing: "Pricing",
    city: "City",
    profileUpdated: "Provider profile updated.",
    adminWorkspace: "Platform admin",
    visitors: "Visitors",
    subscribers: "Subscribers",
    providers: "Providers",
    platformStats: "Platform stats",
    pendingProviders: "Provider requests",
    validateProvider: "Approve",
    platformDashboard: "Platform dashboard"
  }
}[locale] || getAppCopy("fr"));
